<span class="btn-container">
  <app-button
    (click)="csvExportDevices()"
    [black]="true"
    [title]="'resources.export_devices' | translate"
    class="flex-position-end btn-margin"
    header-button
  >
  </app-button>
</span>

<div class="filters-container">
  <mat-form-field appearance="outline" class="filter-field">
    <mat-label>{{ 'resources.search.unit_no' | translate }}</mat-label>
    <input
      matInput
      [value]="searchUnitNo"
      (input)="onUnitNoSearchChange($any($event.target).value)"
    />
  </mat-form-field>

  <mat-form-field appearance="outline" class="filter-field">
    <mat-label>{{ 'resources.filter.device_type' | translate }}</mat-label>
    <mat-select
      [value]="selectedDeviceType"
      (selectionChange)="onDeviceTypeFilterChange($event.value)"
    >
      <mat-option [value]="allFilterValue">
        {{ 'resources.filter.all_device_types' | translate }}
      </mat-option>
      <mat-option
        *ngFor="let option of deviceTypeFilterOptions"
        [value]="option.value"
      >
        {{ option.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="filter-field">
    <mat-label>{{ 'resources.filter.model' | translate }}</mat-label>
    <mat-select
      [value]="selectedModel"
      (selectionChange)="onModelFilterChange($event.value)"
    >
      <mat-option [value]="allFilterValue">
        {{ 'resources.filter.all_models' | translate }}
      </mat-option>
      <mat-option
        *ngFor="let option of modelFilterOptions"
        [value]="option.value"
      >
        {{ option.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field
    *ngIf="useAllDevices"
    appearance="outline"
    class="filter-field"
  >
    <mat-label>{{ 'resources.filter.company' | translate }}</mat-label>
    <mat-select
      [value]="selectedCompany"
      (selectionChange)="onCompanyFilterChange($event.value)"
    >
      <mat-option [value]="allFilterValue">
        {{ 'resources.filter.all_companies' | translate }}
      </mat-option>
      <mat-option
        *ngFor="let option of companyFilterOptions"
        [value]="option.value"
      >
        {{ option.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>

<qs-table
  testId="device-table"
  [rowTestIdFn]="deviceRowTestId"
  [data]="filteredDevices"
  [columns]="columns"
  [onRowClickFn]="goToDrone"
  [isSearchEnabled]="isSearchEnabled"
  [isPaginatorEnabled]="isPaginatorEnabled"
  [paginatorConfig]="paginatorConfig"
>
</qs-table>
